import ApiConstants from '../ApiConstants';
import connectAPI from '../connectApi';

export default function validateClient(params, token) {
  return connectAPI(ApiConstants.VALID_CLIENT_URL, params, 'post', token);
}